import React from "react";

function UploadBox({ text }) {
  return (
    <label style={{
      flex: 1,
      minWidth: "260px",
      height: "65px",
      border: "1px dashed #cccccc",
      borderRadius: "6px",
      background: "#fff",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      cursor: "pointer",
      margin: "0 7px 7px 0",
      transition: "border-color 0.2s"
    }}>
      {/* Upload SVG Icon */}
      <svg style={{width: "24px", height: "24px", marginBottom: "3px", opacity: 0.6}} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 9l5-5 5 5M12 4v12"/>
      </svg>
      <span style={{
        color: "#667ca3",
        fontSize: "13px",
        textAlign: "center",
        fontFamily: "inherit"
      }}>{text}</span>
      <input
        type="file"
        style={{
          opacity: 0,
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          cursor: "pointer"
        }}
      />
    </label>
  );
}

function InventoryPricingForm({onPrevious}) {
  const handlePrevious = (e) => {
    e.preventDefault();
    if (onPrevious) onPrevious(); // go back one tab
  };
  return (
    <form style={{
      display: "flex", flexDirection: "column", gap: "12px"
    }}>
      <h2 className="justify-content-center" style={{fontSize: "1.2rem"}}>Inventory & Pricing</h2>
      <div style={{ display: "flex", gap: "14px", flexWrap: "wrap" }}>
        <div style={groupStyle}>
          <label>Initial Quantity </label>
          <input style={inputStyle} type="number"  />
        </div>
        <div style={groupStyle}>
          <label style = {{fontSize:"15px"}}>Reorder Level</label>
          <input style={inputStyle} type="number" />
        </div>
        <div style={groupStyle}>
          <label style = {{fontSize:"15px"}}>Maximum Level</label>
          <input style={inputStyle} type="number" />
        </div>
      </div>
      <div style={rowStyle}>
        <div style={groupStyle}>
          <label style = {{fontSize:"15px"}}>Purchase Price </label>
          <input style={inputStyle} type="number"  />
        </div>
        <div style={groupStyle}>
          <label style = {{fontSize:"15px"}}>Selling Price </label>
          <input style={inputStyle} type="number"  />
        </div>
        <div style={groupStyle}>
          <label style = {{fontSize:"15px"}}>Tax Rate (%)</label>
          <input style={inputStyle} type="number" />
        </div>
      </div>
      <div style={groupStyle}>
        <label style = {{fontSize:"15px"}}>Storage Conditions</label>
        <div style={{
          display: "flex", gap: "16px", flexWrap: "wrap"
        }}>
          <label><input type="checkbox" /> Room Temperature</label>
          <label><input type="checkbox" /> Frozen</label>
          <label><input type="checkbox" /> Refrigerated</label>
          <label><input type="checkbox" /> Protect from Light</label>
        </div>
      </div>
      {/* Updated image upload section */}
      <div style={groupStyle}>
        <label>Upload Images</label>
        <div style={{
          display: "flex",
          gap: "12px",
          flexWrap: "wrap",
          background: "#fff",
          padding: 0
        }}>
          <UploadBox text="Click to upload medicine image" />
          <UploadBox text="Click to upload package image" />
        </div>
      </div>
      <div style={actionStyle}>
        <button type="button" className="gradient-dark-button" onClick={handlePrevious}>Previous</button>
        <button type="submit" className="gradient-button px-3">Save Medicine</button>
      </div>
    </form>
  );
}

// Internal CSS objects
const inputStyle = {
  padding: "6px",
  borderRadius: "3px",
  border: "1px solid #dedede",
  fontSize: "13px",
};
const rowStyle = {
  display: "flex",
  gap: "14px",
  flexWrap: "wrap",
};
const groupStyle = {
  flex: "1",
  display: "flex",
  flexDirection: "column",
  
  gap: "6px",
  minWidth: "210px",
};
const actionStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "10px",
};
const btnStyle = {
  padding: "8px 18px",
  border: "none",
  borderRadius: "3px",
  background: "#1921a4",
  color: "#fff",
  cursor: "pointer",
  fontSize: "13px",
  marginLeft: "6px",
};
const cancelBtnStyle = {
  ...btnStyle,
  background: "#555",
};

export default InventoryPricingForm;
